// Sprint 1 — Onboarding post-registro
import { cva } from "styled-system/css";

export const onboardingChoiceCard = cva({
  base: {
    cursor: "pointer",
    rounded: "xl",
    borderWidth: "2px",
    borderColor: "#e2e8f0",
    bg: "#f8fafc",
    p: "5",
    textAlign: "left" as const,
    display: "flex",
    flexDir: "column" as const,
    gap: "3",
    transition: "border-color 0.15s, background 0.15s, box-shadow 0.15s",
    _hover: { borderColor: "#cbd5e1", bg: "white" },
  },
  variants: {
    selected: {
      true: {
        borderColor: "token(colors.brand.500)",
        bg: "white",
        boxShadow: "0 0 0 3px rgba(99, 102, 241, 0.15)",
      },
      false: {},
    },
    wide: {
      true: { gridColumn: "1 / -1" },
      false: {},
    },
  },
  defaultVariants: {
    selected: false,
    wide: false,
  },
});
